import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Container, Typography, CircularProgress, Alert, Button, Box } from "@mui/material";
import  SessionStorageService  from "../../services/StorageService";
import EdevletAPI from "../../apis/OB/KPS/EdevletAPI";
import { toast } from "react-toastify";
import { ConstantAPISContext } from "../../context/ConstantAPISContext";

const OAuthTRCallbackPage = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const {setKullaniciVarmi}=useContext(ConstantAPISContext)

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const code = params.get("code");
    console.log("coming e devlet code:",code);
    // Eğer kod yoksa hata mesajı göster
    if (!code) {
      setError("Yetkilendirme kodu bulunamadı! Lütfen tekrar giriş yapın.");
      setLoading(false);
      return;
    }

    // Aynı yetkilendirme kodunun tekrar işlenmesini önle
    const storedCode = sessionStorage.getItem("last_code");
    if (storedCode === code) {
      setError("Bu yetkilendirme kodu zaten işlendi, tekrar işleme alınmayacak.");
      setLoading(false);
      return;
    }

    // Yetkilendirme kodunu backend'e gönder
   EdevletAPI.getAccessCode(code)
      
      .then((res) => {
        
        console.log("Kullanıcı Bilgileri:", res);
       if(res.success){
        const userInfo = {
          ...res.data,
          tcKimlikNo: String(res.data.tcKimlikNo)
        };
      
        // Sonra bunu saklıyoruz
        SessionStorageService.setUserInfo(userInfo);
        sessionStorage.setItem("last_code", code); // Aynı kodu tekrar işlememek için sakla
        setKullaniciVarmi(true)
        toast.success("Giriş işlemi başarılı")
        navigate("/"); // Kullanıcıyı yönlendir
       }else{
        setError(res.message || "Bilinmeyen bir hata oluştu.");

       }
      })
      .catch((err) => {
        console.error("Giriş hatası:", err);
        setError(err.message || "Bilinmeyen bir hata oluştu.");
      })
      .finally(() => {
        setLoading(false);
      });
  }, [navigate]);

  return (
    <Container maxWidth="sm" sx={{ textAlign: "center", mt: 5 }}>
      {loading ? (
        <Box display="flex" flexDirection="column" alignItems="center">
          <CircularProgress size={60} />
          <Typography variant="h6" sx={{ mt: 2 }}>
            Giriş yapılıyor, lütfen bekleyin...
          </Typography>
        </Box>
      ) : error ? (
        <Box>
          <Alert severity="error" sx={{ mb: 2 }}>
            {error}
          </Alert>
          <Button variant="contained" color="primary" onClick={() => navigate("/")}>
            Ana Sayfaya Dön
          </Button>
        </Box>
      ) : null}
    </Container>
  );
};

export default OAuthTRCallbackPage;
